import {
  IonContent,
  IonPage,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonList,
  IonSpinner,
  IonText,
} from '@ionic/react';

import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { LeagueAdminItems } from './components/LeagueAdminItems';
import { LeaveLeagueItem } from './components/LeaveLeagueItem';

// What the current user can see on the settings page, resolved from their membership.
export type LeagueSettingsAccess = 'loading' | 'error' | 'notMember' | 'member' | 'admin';

interface LeagueSettingsPageProps {
  leagueId: string;
  access: LeagueSettingsAccess;
  currentMemberId?: string;
  currentMemberRole?: string;
}

// League settings, open to every member. Admin options are only shown to
// admins/creators; leaving the league is available to every member. Nothing is
// shown until the membership is resolved, so non-members never see the options.
export const LeagueSettingsPage = ({ leagueId, access, currentMemberId, currentMemberRole }: LeagueSettingsPageProps) => (
  <IonPage>
    <AppSectionHeader variant="fantasy">
      <IonToolbar>
        <IonButtons slot="start">
          <IonBackButton defaultHref={`/app/ligas/${leagueId}/equipo`} />
        </IonButtons>
        <IonTitle className="ml-4">Ajustes</IonTitle>
      </IonToolbar>
    </AppSectionHeader>

    <IonContent className="ion-padding">
      {access === 'loading' && (
        <div className="flex justify-center items-center min-h-[200px]">
          <IonSpinner name="crescent" />
        </div>
      )}

      {access === 'error' && (
        <IonText color="danger">
          <p>Error al cargar los ajustes de la liga</p>
        </IonText>
      )}

      {access === 'notMember' && (
        <IonText>
          <p>No eres miembro de esta liga</p>
        </IonText>
      )}

      {(access === 'member' || access === 'admin') && (
        // A single list so every option shares the same spacing
        <IonList>
          {access === 'admin' && (
            <LeagueAdminItems
              leagueId={leagueId}
              currentMemberId={currentMemberId}
              currentMemberRole={currentMemberRole}
            />
          )}
          <LeaveLeagueItem leagueId={leagueId} />
        </IonList>
      )}
    </IonContent>
  </IonPage>
);
